import {
    Box,
    LinearProgress,
    Paper,
    Typography,
} from "@mui/material";
import { COLORS } from "../../../dashboard/epis-dashboard/configs/config";
export default function Card({ title, subtitle, loading, children }) {
    return (
        <Paper variant="outlined" sx={{ p: 2, height: "100%", bgcolor: COLORS.card, borderColor: COLORS.border, borderRadius: 2, position: "relative", overflow: "hidden" }}>
            <Typography sx={{ fontWeight: 600, color: COLORS.tPri }}>{title}</Typography>
            {subtitle && <Typography variant="caption" sx={{ color: COLORS.tDim }}>{subtitle}</Typography>}
            {loading && <LinearProgress sx={{ position: "absolute", top: 0, left: 0, right: 0 }} />}
            <Box sx={{ mt: 1.5, opacity: loading ? 0.4 : 1, transition: "opacity .2s" }}>{children}</Box>
        </Paper>
    );
}